<template>
    <div class="input-group mb-3">
        <input data-form-type="other" placeholder="Email" type="email" v-model="email" class="form-control" />
        <input data-form-type="other" placeholder="SCN" type="text" v-model="scn" class="form-control" />
        <input data-form-type="other" placeholder="Site"  type="text" v-model="site" class="form-control" />
        <select v-model="product" class="form-control">
            <option value="all">All Products</option>
            <option v-for="product in productList" :key="product.product_id" v-bind:value="product.product_id">{{product.product}}</option>
        </select>
        <select v-model="selectedExport" class="form-control">
            <option value="all">All Statuses</option>
            <option value="0">Pending</option>
            <option value="1">Success</option>
            <option value="2">Did not opt in</option>
            <option value="5">Spam</option>
            <option value="8">Missing name</option>
            <option value="9">Error</option>
        </select>
        <select v-model="selectedType" class="form-control">
            <option value="all">All Export Types</option>
            <option v-for="type in optionsTypes" :key="type" v-bind:value="type">{{type}}</option>
        </select>
        <select class="form-control" v-model="selectedTime">
            <option value="1hr">1 hr</option>
            <option value="6hr">6 hr</option>
            <option value="12hr">12 hr</option>
            <option value="24hr">24 hr</option>
            <option value="today">Today</option>
            <option value="2days">2 Days</option>
            <option value="7days">7 Days</option>
            <option value="week">This Week</option>
            <option value="month">This Month</option>
            <option value="1mth">1 Month</option>
            <option value="3mth">3 Month</option>
            <option value="6mth">6 Month</option>
            <option value="quarter">This Quarter</option>
            <option value="year">This Year</option>
            <option value="1yr">1 Year</option>
        </select>
        <button v-on:click="search" class="btn btn-secondary ml-1 rounded-none">Search</button>
    </div>
</template>

<script>

import {updateQuerySting, newLocation, getQueryValue} from '../lib/helpers';

export default {
    props: {
        exportNumbers: Array,
        types: Array,
        products: Array,
    },
    data () {
        return {
            email: '',
            site: '', 
            scn: '',
            product: '',
            selectedExport: 'all',
            selectedType: 'all',
            optionsTypes: [],
            selectedTime: '2days',
            productList: [],
        }
    },
    beforeMount() {
        this.selectedExport = getQueryValue('exported', 'all');
        this.selectedType = getQueryValue('sendToType', 'all');
        this.email = getQueryValue('email', '');
        this.scn = getQueryValue('scn', '');
        this.site = getQueryValue('site', '');
        this.product = getQueryValue('product', 'all');
        this.selectedTime = getQueryValue('timeSpan', '2days');
        this.optionsTypes = this.types;
        this.productList = this.products;
    },
    methods: {
        search() {
            let query = updateQuerySting('exported', this.selectedExport);
            query = updateQuerySting('sendToType', this.selectedType, query);
            query = updateQuerySting('email', this.email, query);
            query = updateQuerySting('site', this.site, query);
            query = updateQuerySting('scn', this.scn, query);
            query = updateQuerySting('product', this.product, query);
            query = updateQuerySting('timeSpan', this.selectedTime, query);

            newLocation(null, query);
        }
    }   
}

</script>

